import {Injectable, NgZone, OnDestroy} from '@angular/core';
import {SessionEventType, SessionEvent} from '../models/session';
import {MatDialog} from '@angular/material/dialog';
import {NavigateService} from 'ngx-satoris';
import {ApiService} from './api.service';

@Injectable({
  providedIn: 'root'
})
export class SessionService implements OnDestroy {
  // Channel used for cross-tab communication
  private readonly channel = new BroadcastChannel('evisa_session');
  // Tracks if current tab is blocked
  isBlocked = false;
  // Unique identifier for this tab session
  private sessionId = Date.now().toString();

  constructor(private zone: NgZone,
   private dialog: MatDialog,
   private nav: NavigateService,
   private api: ApiService) {
    if(!this.api.isElectronApp) {
      this.setupMessageListener();
      // Broadcast presence when tab starts
      this.channel.postMessage({
        type: SessionEventType.NEW_SESSION,
        sessionId: this.sessionId
      });
    }
  }

  private setupMessageListener() {
    this.channel.onmessage = (event: MessageEvent<SessionEvent>) => {
      if(this.api.isElectronApp) return;
      switch(event.data.type) {
      case SessionEventType.NEW_SESSION:
        this.cleanDialogAndUpdateState(true);
        break;

      case SessionEventType.SESSION_REACTIVATED:
        // Block current tab if another one was reactivated
        if(event.data.sessionId !== this.sessionId) {
          this.cleanDialogAndUpdateState(true);
        }
        break;
      }
    };
  }

  /**
  * Makes this tab active and blocks all others
  */
  reactivateTab() {
    if(this.api.isElectronApp) return;
    this.sessionId = Date.now().toString();
    this.cleanDialogAndUpdateState(false);
    this.channel.postMessage({
      type: SessionEventType.SESSION_REACTIVATED,
      sessionId: this.sessionId
    });
  }

  private cleanDialogAndUpdateState(blocked: boolean) {
    if(this.api.isElectronApp) return;
    this.nav.to('dashboard');
    this.dialog.closeAll();
    this.zone.run(() => {
      this.isBlocked = blocked;
    });
  }

  ngOnDestroy() {
    if(!this.api.isElectronApp) {
      this.channel.close();
    }
  }
}